import ReactDatetime from "react-datetime";

// `react-datetime` is published as CommonJS. Depending on the bundler's
// interop, the default import can arrive as the module *namespace*
// (`{ default: Datetime }`) rather than the `Datetime` component itself —
// Vite 8's dependency pre-bundling does exactly this, which makes React throw
// "Element type is invalid ... but got: object" when the value is rendered.
// Normalise to the component regardless of which shape we receive (the
// `?? ReactDatetime` fallback covers bundlers/test mocks that already hand back
// the component directly).
const ReactDatetimeClass =
	(ReactDatetime as { default?: typeof ReactDatetime }).default ??
	ReactDatetime;

export default ReactDatetimeClass;
